import React from 'react';
import { FiEdit } from 'react-icons/fi';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import { reDirectPage, setDash, setDetailPageUrl } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { COUPON_ISSUE_HISTORY_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';

/**
 *  쿠폰 발급 이력 리스트 컬럼
 */
export const columns = () => {
  return [
    {
      title: <TableColumnTitle title={'상세보기'} />,
      dataIndex: 'detail',
      render: (value, record) => (
        <FiEdit
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(COUPON_ISSUE_HISTORY_DETAIL_URL_PATH, record.couponIssueHistoryId),
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'발급 이력 id'} />,
      dataIndex: 'couponIssueHistoryId',
    },
    {
      title: <TableColumnTitle title={'발급한 관리자'} />,
      dataIndex: 'adminName',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      title: <TableColumnTitle title={'메모'} />,
      dataIndex: 'memo',
      render: (value) => setDash(value),
    },
  ];
};
